export default __webpack_public_path__ + "static/media/icn-arrow-open-search.61cc147f.svg";